import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiAction } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import ObjectViewer from '../Common/ObjectViewer';
import { parseJSON } from '../../utils/helpers';

const PendingAd = () => {
  const dispatch = useDispatch();
  const { pending_id } = useParams();
  const { pendingAd } = useSelector((state) => state.general);
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'pendingAd',
        route: 'pendingAds/getPendingAdById',
        id: pending_id,
      })
    );
  }, [dispatch, pending_id]);
  console.log({ pendingAd });
  return pendingAd?._id ? (
    (() => {
      const parsedPendingAd = {
        ...pendingAd,
        originalAdData: parseJSON(pendingAd.originalAdData),
        payloadForAd: parseJSON(pendingAd.payloadForAd),
        payloadForCreative: parseJSON(pendingAd.payloadForCreative),
      };
      return (
        <div data-aos='fade-up' data-aos-delay='200'>
          <div className='row d-flex justify-content-center mt-4 border-bottom'>
            <h1>
              Pending Ad: <span className='text-primary'>{pendingAd._id}</span>
            </h1>
          </div>
          <div className='row d-flex justify-content-center mt-4 '>
            <ObjectViewer data={parsedPendingAd} />
          </div>
        </div>
      );
    })()
  ) : (
    <Spinner />
  );
};

export default PendingAd;
